<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12"
             sm="8">
        <v-form @submit.prevent="submit"
                ref="form"
                :disabled="form.busy"
                class="mb-4">
          <v-card>
            <v-card-title>
              Ashfield Account Executive Introduction Letter
            </v-card-title>
            <v-card-text>
              <v-text-field v-model="form.recipient_name"
                            label="Recipient Name"
                            placeholder=" "
                            autocomplete="off"
                            :rules="[rules.required]"
                            :error-messages="form.errors.get('recipient_name')">
              </v-text-field>

              <v-autocomplete v-model="form.ae_id"
                              :items="accountExecutives"
                              item-value="id"
                              item-text="name"
                              label="Account Executive"
                              placeholder=" "
                              :rules="[rules.required]"
                              :error-messages="form.errors.get('ae_id')">
              </v-autocomplete>

            </v-card-text>
            <v-card-actions>
              <v-btn type="submit"
                     color="primary"
                     :disabled="form.busy">
                <v-icon left
                        v-if="form.busy">
                  fal fa-fw fa-spin fa-spinner
                </v-icon>
                Create Letter
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>

        <v-card>
          <v-card-title>
            View Existing Letters
          </v-card-title>
          <v-list>

            <v-list-item v-for="letter in letters"
                         :key="letter.id"
                         :href="`/admin/presentations/${letter.id}/open`"
                         target="_blank"
                         two-line>
              <v-list-item-icon>
                <v-icon>
                  fal fa-file-pdf
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ letter.name }}
                </v-list-item-title>
                <v-list-item-subtitle v-if="letter.owner_id && owner(letter.owner_id)">
                  AE: {{ owner(letter.owner_id).name }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12"
             sm="4">
        <v-card>
          <v-card-title>
            Instructions
          </v-card-title>
          <v-card-text>
            <p>
              <strong>Step 1:</strong> Enter the recipient's name and credentials (if appropriate), exactly as you want it to appear in the letter.<br/>
              Example: <code>John Doe, MD</code>
            </p>
            <p>
              <strong>Step 2:</strong> Select the Account Executive from the dropdown.
            </p>
            <p>
              <strong>Step 3:</strong> Click <strong>Create Letter</strong>.
            </p>
            <p>
              <strong>Step 4:</strong> In Outlook, compose a new email to the recipient, or use a template. Open the Mobile Locker sidebar by clicking <strong>Share Content</strong>.
            </p>
            <p>
              <strong>Step 5:</strong> Open the "Ashfield Account Executives" folder.
            </p>
            <p>
              <strong>Step 6:</strong> In the Mobile Locker sidebar, click <strong>Menu > Refresh</strong> to make the new letter appear.
            </p>
            <p>
              <strong>Step 7:</strong> Select the letter and click Insert Link.
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import formValidation from '../../../plugins/formValidation';
import {find, orderBy} from 'lodash';
import echo from '../../../plugins/echo';

export default {
  mixins: [formValidation],
  data() {
    return {
      form: new Form({
        recipient_name: '',
        ae_id: '',
        presentation_name: '',
      })
    }
  },
  computed: {
    ...mapGetters([
      'activeUsers',
      'presentations',
      'team',
      'user',
    ]),
    accountExecutives() {
      return this.activeUsers.filter(u => {
        const groupIDs = u.groups.map(g => g.id);
        return groupIDs.includes(970)
          || u.is_employee;
      })
    },
    letters() {
      return orderBy(this.presentations.filter(p => {
        return (p.name.startsWith('Scilex Account Executive for'));
      }), ['slug'], ['asc']);
    },
  },
  created() {
    this.initForm();
    this.fetchData();
    this.initEcho();
  },
  methods: {
    initEcho() {
      const team = this.team;
      if (team) {
        console.log('initEcho', team.channel);
        echo.private(team.channel)
          .listen('Models.Presentation.Deleted', e => {
            console.log('Ashfield Letter', e.message);
            //this.$toast.success(e.message);
            this.fetchData();
          })
          .listen('Models.Presentation.Processed', e => {
            console.log('Ashfield Letter', e.message);
            //this.$toast.success(e.message);
            this.fetchData();
          });
      } else {
        console.log('team is null');
      }
    },
    owner(userID) {
      return find(this.activeUsers, u => u.id === userID);
    },
    async fetchData() {
      await this.$store.dispatch('fetchPresentations');
      await this.$store.dispatch('fetchUsers');
    },
    initForm() {
      this.form.ae_id = this.user.id;
    },
    resetForm() {
      this.$refs.form.resetValidation();
    },
    async submit() {
      if (this.form.busy) {
        return;
      }
      await this.form.post(`/api/clients/scilex/ashfield-letter`)

      this.form.busy = true;

      setTimeout(() => {
        this.fetchData();
        this.resetForm();
        this.initForm();
        this.form.busy = false;
      }, 5000);
    }
  }
}
</script>
